import React, {useContext,useEffect,useState} from 'react'
import { formularioContext } from '../contextos/FormularioContext'
import Swal from 'sweetalert2';
import {Dialogos} from './Dialogos'
import {DatosPersonalesMinExterno} from './DatosPersonalesMinExterno'
import { ETPago } from './ETPago';
import {Card, CardHeader, CardActions, CardContent,Typography, Button, Alert, Box,Grid,CardMedia} from '@mui/material'

export const ETNuevaInscripcion = ({id_evento,eventoSeleccionado,cancelar})=>{
    const { datos,
        descripcionProvincia,
        reinicializar,
        buscarHabilitacionExterno,
        datosMinistroOk,
        infoMinistro,
        setIdEvento,
        generarPreferencia,
        eventoValorSeleccionado,
        validarMinistroEventoSeleccionado} = useContext(formularioContext)
        const [inscriptoPrincipalCargado,setInscriptoPrincipalCargado]= useState(true)
        const [pedirDatosMinExterno,setPedirDatosMinExterno] = useState(false)

    useEffect(()=>{
        setIdEvento(id_evento)
    },[id_evento])

    const cancelarBusquedaDatos = ()=>{
        setInscriptoPrincipalCargado(false)
        setPedirDatosMinExterno(false)
        reinicializar()
    }

const procesarMinistroExterno = ()=>{
    if(datosMinistroOk()[0]){
        setPedirDatosMinExterno(false)    
        setInscriptoPrincipalCargado(true)
    }else{
        Swal.fire({
            html:`<p>${datosMinistroOk()[1]}</p>`,
            icon: 'warning',
            customClass: 'slow-animation',
            confirmButtonColor: '#3085d6',
        })   
    }
}

if(!datos.cant_max_personas){
    <Alert severity="info" variant='outlined'>
            El item seleccionado no tiene definida la cantidad de personas a inscribir
    </Alert>
} 

if(!validarMinistroEventoSeleccionado()[0]){
    return <Box>  
            <Typography sx={{color:'firebrick',fontWeight:500}} variant="h5">Entrada no disponible</Typography>
            <Typography sx={{fontSize:'small'}} variant="subtitle">{validarMinistroEventoSeleccionado()[1]}</Typography>
        </Box>
}

return <>
        {inscriptoPrincipalCargado && datosMinistroOk()[0] && <Box sx={{marginTop:'2rem'}}>
        {!datosMinistroOk()[0] && <p>{datosMinistroOk()[1]}</p>}   
        {datosMinistroOk()[0] && 
                <ETPago datos={datos} 
                generarPreferencia={generarPreferencia} 
                descripcionProvincia={descripcionProvincia} 
                datosMinistroUad={infoMinistro}
                id_evento={id_evento} 
                buscarHabilitacionExterno={buscarHabilitacionExterno}
                eventoValorSeleccionado={eventoValorSeleccionado}
                eventoSeleccionado={eventoSeleccionado}
                cancelar={cancelar}
                />}                
    </Box>
    
}
<FormularioMinistroExterno
            pedirDatosMinExterno = {pedirDatosMinExterno}
            procesarMinistroExterno = {procesarMinistroExterno} 
            cancelarBusquedaDatos={cancelarBusquedaDatos}
        />
</>


}

const FormularioMinistroExterno = ({pedirDatosMinExterno,procesarMinistroExterno,cancelarBusquedaDatos})=>{
    return <Dialogos open={pedirDatosMinExterno} 
                        titulo='Ingrese sus datos personales' 
                        procesarResultado={procesarMinistroExterno}
                        procesarCancelar = {cancelarBusquedaDatos || false}
                       >
                  <DatosPersonalesMinExterno/>
    </Dialogos>
    }

